/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/last.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'This function calculates the latest occurrence of the search field\n(the first parameter), where sorting order is determined by the sort\nfield (the second parameter). This sorting order is always ascending\nand null values always sort last. Both fields support null,\nsingle-valued, and multi-valued input. If the latest sort field\nvalue appears in multiple documents, this function is allowed to\nreturn any corresponding search field value.',
  examples: [
    '        @timestamp        |  name   | number\n"2025-11-25T00:00:00.000Z | alpha   | 1"\n"2025-11-25T00:00:01.000Z | alpha   | 2"\n"2025-11-25T00:00:02.000Z | bravo   | null"\n"2025-11-25T00:00:03.000Z | alpha   | 4"\n"2025-11-25T00:00:04.000Z | bravo   | 5"\n"2025-11-25T00:00:05.000Z | charlie | [6, 7, 8]"\n"2025-11-25T00:00:06.000Z | delta   | null"\n\nFrom dataset\n| STATS last_val = LAST(number, @timestamp) BY name',
  ],
  params: {
    field: 'The search field',
    sortField: 'The sort field',
  },
};

export default docs;
